import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import GrowingCircleShell from "@/modules/growing-circle/Shell";
import PageviewBeacon from "@/lib/PageviewBeacon";
import ScrollToTop from "@/lib/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PageviewBeacon />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/en" element={<Landing />} />
          <Route path="/it" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Growing Circle module — scoped subtree; internal routes handled
              by /app/frontend/src/modules/growing-circle/Router.jsx */}
          <Route path="/growing-circle/*" element={<GrowingCircleShell />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
